import { actionCreatorFactory } from '@core/utils/factories';
import {
  EngineeringBrowseResponse,
  EngineeringSOFTabData,
  EngineeringSummaryTabData,
  EngineeringWorkflowTabData,
  EngineeringWorkflowUpdateData,
  PaginatedResponse,
  UpdateEngineeringSOFData,
} from '@models/interfaces';

const actionCreator = actionCreatorFactory('ENGINEERING');

export namespace EngineeringActions {
  export const getEngineeringBrowseDataAction =
    actionCreator.createAsyncAction<
      PaginatedResponse<EngineeringBrowseResponse>
    >('GET_BROWSE_DATA');
  export const getEngineeringSummaryAction =
    actionCreator.createAsyncAction<EngineeringSummaryTabData>(
      'GET_ENGINEERING_SUMMARY',
    );
  export const getEngineeringWorkflowAction =
    actionCreator.createAsyncAction<EngineeringWorkflowTabData>(
      'GET_ENGINEERING_WORKFLOW',
    );
  export const getEngineeringSOFAction =
    actionCreator.createAsyncAction<EngineeringSOFTabData>(
      'GET_ENGINEERING_SOF',
    );
  export const setTabLoading = actionCreator.createAsyncAction<{
    tabName: string;
    isLoading: boolean;
  }>('SET_TAB_LOADING');
  export const setTabLoaded = actionCreator.createAsyncAction<{
    tabName: string;
    isLoaded: boolean;
  }>('SET_TAB_LOADED');
  export const setTabError = actionCreator.createAsyncAction<{
    tabName: string;
    hasError: boolean;
  }>('SET_TAB_ERROR');
  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');
  export const updateEngineeringWorkflowAction =
    actionCreator.createAsyncAction<EngineeringWorkflowUpdateData>(
      'UPDATE_ENGINEERING_WORKFLOW',
    );
  export const updateEngineeringSOFAction =
    actionCreator.createAsyncAction<UpdateEngineeringSOFData>(
      'UPDATE_ENGINEERING_SOF',
    );
}
